module.exports = __webpack_public_path__ + "3294314bbe674823299845324145b7b2.png";